import _defineProperty from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var DataQuery1 = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(DataQuery1, _BaseTransformer);
  var _super = _createSuper(DataQuery1);
  function DataQuery1() {
    _classCallCheck(this, DataQuery1);
    return _super.apply(this, arguments);
  }
  _createClass(DataQuery1, null, [{
    key: "fetch",
    value: function fetch(data) {
      var _ref;
      if (!data) {
        data = {
          all_tasks: 0,
          starred: false,
          open_tasks: 0,
          open_threads: 0,
          tasks_in_backlog: 0,
          active_tasks: 0,
          tasks_in_progress: 0,
          open_tasks_duration: 0,
          overdue_tasks: 0,
          overdue_tasks_duration: 0,
          task_dependencies: 0,
          task_dependencies_duration: 0,
          total_time_estimation: 0,
          total_time: 0,
          total_time_estimation_rate: 0,
          total_time_estimation_rate_tooltip: 0,
          total_time_billable_rate: 0,
          total_time_billable_rate_tooltip: 0,
          total_time_non_billable_rate: 0,
          total_time_non_billable_rate_tooltip: 0,
          total_time_billable: 0,
          total_time_non_billable: 0
        };
      }
      return _ref = {
        record_owner: data && data.record_owner ? {
          value: data.record_owner,
          label: data.record_owner_label
        } : {
          value: '',
          label: ''
        },
        active_tasks: data && data.open_tasks ? data.open_tasks + data.tasks_in_progress : 0,
        tasks_in_backlog: data && data.tasks_in_backlog ? data.tasks_in_backlog : 0,
        tasks_in_progress: data && data.tasks_in_progress ? data.tasks_in_progress : 0,
        all_tasks: data && data.total_count ? data.total_count : 0,
        last_update_date: data && data.last_update_date ? data.last_update_date : '',
        last_update_message: data.last_update_message,
        last_update_owner: data.last_update_owner,
        project_status_label: data.project_status_label,
        group_name: data && data.group_name ? data.group_name : '',
        due_date: data && data.due_date ? data.due_date : '',
        start_date: data && data.start_date ? data.start_date : '',
        project_name: data && data.project_name ? data.project_name : '',
        project_id: data && data.project_id ? data.project_id : '',
        project_selected: false,
        project_status_color: data && data.project_status_color ? data.project_status_color : '',
        starred: false,
        my_favorite_id: data && data.my_favorite_id ? data.my_favorite_id : '',
        favoriteId: '',
        team: data && data.team ? data.team : 0,
        open_tasks: data && data.open_tasks ? data.open_tasks : 0,
        open_threads: data && data.open_threads ? data.open_threads : 0,
        open_tasks_duration: data && data.open_tasks_duration ? data.open_tasks_duration : 0,
        overdue_tasks: data && data.overdue_tasks ? data.overdue_tasks : 0,
        overdue_tasks_duration: data && data.overdue_tasks_duration ? data.overdue_tasks_duration : 0,
        task_dependencies: data && data.task_dependencies ? data.task_dependencies : 0,
        task_dependencies_duration: data && data.task_dependencies_duration ? data.task_dependencies_duration : 0,
        total_time_estimation: data && data.total_estimation ? data.total_estimation : 0,
        total_time: data && data.total_time ? data.total_time : 0,
        total_time_estimation_rate: data && data.total_estimation > 0 ? Math.round(data.total_estimation / data.total_time * 100) : 0,
        total_time_estimation_rate_tooltip: data.total_estimation + "(Estimated Duration)" + "/" + data.total_time + "(Total Duration)",
        total_time_billable_rate: data && data.total_time_billable > 0 ? Math.round(data.total_time_billable / data.total_time * 100) : 0,
        total_time_billable_rate_tooltip: data.total_time_billable + "(Billable Duration)" + "/" + data.total_time + "(Total Duration)",
        record_id: data && data.project_id ? data.project_id : '',
        total_time_non_billable_rate: data && data.total_time_non_billable > 0 ? Math.round(data.total_time_non_billable / data.total_time * 100) : 0,
        total_time_non_billable_rate_tooltip: data.total_time_non_billable + "(Non-Billable Duration)" + "/" + data.total_time + "(Total Duration)",
        total_time_billable: data && data.total_time_billable ? data.total_time_billable : 0,
        total_time_non_billable: data && data.total_time_non_billable ? data.total_time_non_billable : 0,
        user_id: data && data.record_owner ? data.record_owner : ''
      }, _defineProperty(_ref, "record_owner", {
        value: data && data.record_owner ? data.record_owner : '',
        label: data && data.record_owner_label ? data.record_owner_label : '',
        color: ''
      }), _defineProperty(_ref, "project_status", {
        value: data && data.project_status ? data.project_status : '',
        color: data && data.project_status_color ? data.project_status_color : '',
        label: data && data.project_status_label ? data.project_status_label : ''
      }), _defineProperty(_ref, "account_name", {
        value: data && data.account_name ? data.account_name.value : '',
        label: data && data.account_name ? data.account_name.label : ''
      }), _defineProperty(_ref, "open_tasks_rate", data && data.open_tasks > 0 ? Math.round((data.total_count - data.open_tasks) / data.total_count * 100) : 0), _defineProperty(_ref, "open_tasks_rate_tooltip", data && data.open_tasks + "(Open Tasks)" + "/" + data.total_count + "(Total Tasks)"), _defineProperty(_ref, "overdue_tasks_rate", data && data.overdue_tasks > 0 ? Math.round(data.overdue_tasks / data.open_tasks * 100) : 0), _defineProperty(_ref, "overdue_tasks_rate_tooltip", data.overdue_tasks + "(Overdue Tasks)" + "/" + data.open_tasks + "(Open Tasks)"), _defineProperty(_ref, "task_dependencies_rate", data && data.task_dependencies > 0 ? Math.round(data.task_dependencies / data.open_tasks * 100) : 0), _defineProperty(_ref, "task_dependencies_rate_tooltip", data.task_dependencies + "(Dependent Tasks)" + "/" + data.open_tasks + "(Open Tasks)"), _defineProperty(_ref, "open_tasks_duration_rate", data && data.open_tasks_duration > 0 ? Math.round(data.open_tasks_duration / data.total_time * 100) : 0), _defineProperty(_ref, "open_tasks_duration_rate_tooltip", data.open_tasks_duration + "(Open Tasks)" + "/" + data.total_time + "(Total Time)"), _defineProperty(_ref, "overdue_tasks_duration_rate", data && data.overdue_tasks_duration > 0 ? Math.round(data.overdue_tasks_duration / data.open_tasks_duration * 100) : 0), _defineProperty(_ref, "overdue_tasks_duration_rate_tooltip", data.overdue_tasks_duration + "(Overdue Tasks)" + "/" + data.open_tasks_duration + "(Open Tasks Time)"), _defineProperty(_ref, "task_dependencies_duration_rate", data && data.task_dependencies_duration > 0 ? Math.round(data.task_dependencies_duration / data.open_tasks_duration * 100) : 0), _defineProperty(_ref, "task_dependencies_duration_rate_tooltip", data && data.task_dependencies_duration + "(Dependent Tasks)" + "/" + data.open_tasks_duration + "(Open Tasks Time)"), _ref;
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return DataQuery1;
}(BaseTransformer);